import { List } from "antd";
import formatNumber from "./FormatNumber";
import i18next from "i18next";
import Data from "../../Types/Data";
import EcheanceFormat from "../../Models/EcheanceFormat";


interface Total{
    TotAnnuite : string,
    TotIt : string,
    TotAm : string,
    TotTaxe : string,
    TotEpargn : string,
    TotAnTTC : string

}

export default class Amortissement{
    public IndiceClient: string;
    public Periodicite: string;
    public MontantEpargne: number;
    public TauxInteretAnnuel: number;
    public NbrePeriodDiffere: number;
    public TypePret: string;
    public TypeAmortissement: string;
    public TauxEpargne: number;
    public NombreEchance: number;
    public MontantPret: number;
    public TypeCalcul: string;
    public TauxTaxe: number;
    public DatePreEcheance: Date;
    public CommissionApplique: number;
    public static totaux : Total;

    constructor(
                IndiceClient: string, 
                Periodicite: string, 
                MontantEpargne: number, 
                TauxInteretAnnuel: number, 
                NbrePeriodDiffere: number, 
                TypePret: string, 
                TypeAmortissement: string, 
                TauxEpargne: number, 
                NombreEchance: number, 
                MontantPret: number, 
                TypeCalcul: string, 
                TauxTaxe: number, 
                DatePreEcheance: Date, 
                CommissionApplique: number
        ){
        this.IndiceClient = IndiceClient;
        this.Periodicite = Periodicite;
        this.MontantEpargne = MontantEpargne;
        this.TauxInteretAnnuel = TauxInteretAnnuel;
        this.NbrePeriodDiffere = NbrePeriodDiffere;
        this.TypePret = TypePret;
        this.TypeAmortissement = TypeAmortissement;
        this.TauxEpargne = TauxEpargne;
        this.NombreEchance = NombreEchance;
        this.MontantPret = MontantPret;
        this.TypeCalcul = TypeCalcul;
        this.TauxTaxe = TauxTaxe;
        this.DatePreEcheance = DatePreEcheance;
        this.CommissionApplique = CommissionApplique;
    }
    
    NextDate(actualDate : Date): Date{
        var pas : number;
        var typ = 'Moi'
        switch (this.Periodicite) {
            case "A":
                pas = 12;    // 12 Mois
                break;
            case "S":
                pas = 6;     // 6 Mois
                break;
            case "T":
                pas = 3;     // 3 Mois
                break;
            case "M":
                pas = 1;     // 1 Moi
                break;
            case "B":
                typ = 'Jour'
                pas = 15;  // 0.5 Moi
                break;
            case "F":
                pas = 2;     // 2 Mois
                break;
            case "H":
                typ = 'Jour'
                pas = 7;     // 7 Jours
                break;
            case "J":
                typ = 'Jour'
                pas = 1;     // 1 Jour
                break;
            default:
                pas = 1;     // 1 Moi
        }

        var d = actualDate ? new Date(actualDate) : new Date();
        if(typ == 'Moi'){
            c = (new Date(d.getFullYear(), d.getMonth() + 1 + pas, 0)).getDate();
            if (d.getDate() > c){
              d.setDate(c);
            }
            d.setMonth(d.getMonth() + pas);

        }else{
            var c = d.getDay();
            d.setDate(d.getDate() + pas);
            if (d.getDay() != c) {
                d = new Date(d.setDate(d.getDate()));
            }

        }
        return d as Date;
    }

    TauxInteretMensuel(): number{
        var Tm : Number;
        let ti = this.TauxInteretAnnuel;
        switch (this.Periodicite) {
            case "A":
                Tm = ti;
                break;
            case "S":
                Tm = (ti / 2);
                break;
            case "T":
                Tm = (ti / 4);
                break;
            case "M":
                Tm = (ti / 12);
                break;
            case "B":
                Tm = (ti / 6);
                break;
            case "F":
                Tm = (ti / 24);
                break;
            case "H":
                Tm = (ti / 52);
                break;
            case "J":
                Tm = (ti / 360);
                break;
            default:
                Tm = ti;
        }
        return Tm as number;
    }

    GetAmortissement(): Array<EcheanceFormat>{
        let Ta = this.TypeAmortissement
        if ((Ta == "C")) {
            return this.AmortConst();
        }
        
        if ((Ta == "V")) {
            return this.AmortVaria();
        }
        
        if ((Ta == "I")) {
            AmortEtIntConst();
        }
        return []
    }

    
    AmortConst() : Array<EcheanceFormat>{

        var tab : Array<EcheanceFormat> = []

        var It : number;
        let Ca = this.MontantPret;
        let Tm = this.TauxInteretMensuel()
        var Ann: number
        let Am;
        var TotEpargn : number = 0;
        var ValTaxe;
        var compteur: number = 0
        var Eparg : number = this.MontantEpargne;

        var TotAnnuite : number = 0
        var TotIt : number = 0
        var TotTaxe : number = 0
        var TotAm : number = 0;
        var date = new Date(this.DatePreEcheance) as Date

        for (let index = 0; index < this.NbrePeriodDiffere; index++) {
            It = parseInt(((Ca * Tm) / 100)+"") 
            Ann = It 
            Am = 0
            //TotEpargn = 0
            this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
            compteur++;

            //Call showresult

            tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language),
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                }
            )

            date = this.NextDate(date)
            TotAnnuite = TotAnnuite + Ann
            TotIt = TotIt + It
            TotTaxe = TotTaxe + ValTaxe
            TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")
            //console.log(TotEpargn)
        }

        Am = parseInt((Ca / this.NombreEchance)+"") //Amortisement = Capital / Nombre Echeance
        compteur++
        It = parseInt(((Ca * Tm) / 100)+"")

        this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
        this.TauxEpargne != null && this.TauxEpargne != 0 ? Eparg = ((Ca * this.TauxEpargne / 100)) : Eparg = this.MontantEpargne

        Ann = Am + It

        //Call showresult
        tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language)+"",
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                
                }
            )
        date = this.NextDate(date)
        TotAnnuite = TotAnnuite + Ann
        TotIt = TotIt + It
        TotAm = TotAm + Am
        TotTaxe = TotTaxe + ValTaxe
        TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")

        for (let index = 0; index < this.NombreEchance-1; index++) {
            if (index == this.NombreEchance-2){
                Am = this.MontantPret - Am*(this.NombreEchance-1)
            }
            Ca = Ca - Am
            It = parseInt(((Ca * Tm) / 100)+"")
            
            this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
            this.TauxEpargne != null && this.TauxEpargne != 0 ? Eparg = ((Ca * this.TauxEpargne / 100)) : Eparg = this.MontantEpargne

            Ann = Am + It
            compteur++ 

            //Call showresult
            tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language)+"",
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                
                }
            )
            date = this.NextDate(date)
            TotAnnuite = TotAnnuite + Ann
            TotIt = TotIt + It
            TotAm = TotAm + Am
            TotTaxe = TotTaxe + ValTaxe
            TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")

        }
        Amortissement.totaux = {
            TotAnnuite : formatNumber(TotAnnuite),
            TotIt : formatNumber(TotIt),
            TotAm : formatNumber(TotAm),
            TotTaxe : formatNumber(TotTaxe),
            TotEpargn : formatNumber(TotEpargn),
            TotAnTTC : formatNumber(TotAnnuite + TotTaxe)
        }

        return tab;
    }

    AmortVaria() : Array<EcheanceFormat>{
        var tab : Array<EcheanceFormat> = []
    
        var It : number;
        let Ca = this.MontantPret;
        let Tm = this.TauxInteretMensuel()
        var Ann: number
        let Am;
        var TotEpargn : number = 0;
        var ValTaxe;
        var compteur: number = 0
        var Eparg : number = this.MontantEpargne;
    
        var TotAnnuite : number = 0
        var TotIt : number = 0
        var TotTaxe : number = 0
        var TotAm : number = 0;
        var date = new Date(this.DatePreEcheance)
    
        for (let index = 0; index < this.NbrePeriodDiffere; index++) {
            It = parseInt(((Ca * Tm) / 100)+"") 
            Ann = It 
            Am = 0
            //TotEpargn = 0
            this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
            compteur++;
    
            //Call showresult
    
            tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language),
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                }
            )
    
            date = this.NextDate(date)
            TotAnnuite = TotAnnuite + Ann
            TotIt = TotIt + It
            TotTaxe = TotTaxe + ValTaxe
            TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")
            //console.log(TotEpargn)
        }
    
        // Ligne de difference entre Amortissement Variable et Constant
        Am = parseInt((Ca * (Tm / 100)) / (Math.pow((1 + (Tm / 100)), this.NombreEchance) - 1)+"")//Amortisement = Capital / Nombre Echeance
        compteur++
        It = parseInt(((Ca * Tm) / 100)+"")
    
        this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
        this.TauxEpargne != null && this.TauxEpargne != 0 ? Eparg = ((Ca * this.TauxEpargne / 100)) : Eparg = this.MontantEpargne
    
        Ann = Am + It
    
        //Call showresult
        tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language)+"",
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                
                }
            )
        date = this.NextDate(date)
        TotAnnuite = TotAnnuite + Ann
        TotIt = TotIt + It
        TotAm = TotAm + Am
        TotTaxe = TotTaxe + ValTaxe
        TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")
    
        for (let index = 0; index < this.NombreEchance-1; index++) {
            // if (index == this.NombreEchance-2){
            //     Am = this.MontantPret - Am*(this.NombreEchance-1)
            // }
            Ca = Ca - Am
            It = parseInt(((Ca * Tm) / 100)+"")
            
            this.TauxTaxe != null ? ValTaxe = ((It * this.TauxTaxe / 100)) : ValTaxe = 0
            this.TauxEpargne != null && this.TauxEpargne != 0 ? Eparg = ((Ca * this.TauxEpargne / 100)) : Eparg = this.MontantEpargne
            
            if (index == this.NombreEchance-2){
                Am = this.MontantPret - TotAm
            }else{
                Am = Ann - It
            }
            compteur++ 
    
            //Call showresult
            tab.push(
                {
                    numSeq : formatNumber(compteur),
                    dateEcheacnce : date.toLocaleDateString(i18next.language)+"",
                    capital : formatNumber(Ca),
                    amortissement : formatNumber(Am),
                    interet : formatNumber(It),
                    taxe : formatNumber(ValTaxe),
                    epargne : formatNumber(Eparg),
                    anHT : formatNumber(Ann),
                    anTTC : formatNumber(Ann+ ValTaxe)
                
                }
            )
            date = this.NextDate(date)
            TotAnnuite = TotAnnuite + Ann
            TotIt = TotIt + It
            TotAm = TotAm + Am
            TotTaxe = TotTaxe + ValTaxe
            TotEpargn = parseInt(TotEpargn+"") + parseInt(Eparg+"")
    
        }
        Amortissement.totaux = {
            TotAnnuite : formatNumber(TotAnnuite),
            TotIt : formatNumber(TotIt),
            TotAm : formatNumber(TotAm),
            TotTaxe : formatNumber(TotTaxe),
            TotEpargn : formatNumber(TotEpargn),
            TotAnTTC : formatNumber(TotAnnuite + TotTaxe)
        }
    
        return tab;
    }

}




function AmortEtIntConst() {
    throw new Error("Function not implemented.");
}
// export default class Amortissement{
//     public CodeAgence: string;
//     public Libelle: string;
//     public DateCreation: string;
//     public Telephone: string;
//     public Ville: string;

//     constructor(CodeAgence: string, Libelle: string, dateCreation: string, Telephone: string, Ville: string){
//         this.CodeAgence = CodeAgence;
//         this.Libelle = Libelle;
//         this.DateCreation = dateCreation;
//         this.Telephone = Telephone;
//         this.Ville = Ville;
//     }
// }